import React from 'react';
import FadeUp from '../ui/FadeUp';
import SafeIcon from '@/common/SafeIcon';

export default function CtaSection() {
  return (
    <div className="bg-dark border-t border-dark-4 section-padding text-center relative overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-cta-radial pointer-events-none"></div>
      <FadeUp>
        <h2 className="font-condensed font-black text-[clamp(42px,5vw,72px)] uppercase leading-none mb-5 relative z-10 text-white">
          Ready to <em className="text-gold not-italic">Reclaim</em><br/>Your Space?
        </h2>
        <p className="text-text-muted text-lg max-w-[500px] mx-auto mb-11 relative z-10">
          Call or text for a free, no-obligation quote. We're local, fast, and ready to help.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center relative z-10">
          <a href="tel:4433592010" className="font-condensed font-black text-[28px] tracking-[0.02em] text-text no-underline flex items-center gap-2.5 py-3.5 px-8 border-2 border-gold rounded">
            <SafeIcon name="Phone" className="text-xl" /> 443-359-2010
          </a>
          <a href="mailto:shorejunk1111@gmail.com" className="bg-transparent text-text py-4 px-7 rounded border-[1.5px] border-dark-4 font-condensed font-bold text-[17px] tracking-wide uppercase no-underline inline-flex items-center gap-2">
            <SafeIcon name="Mail" /> shorejunk1111@gmail.com
          </a>
        </div>
      </FadeUp>
    </div>
  );
}